import { render } from "./revisions_modal.vue?vue&type=template&id=08c1448a"
import script from "./revisions_modal.vue?vue&type=script&lang=js"
export * from "./revisions_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/premiergalop/dev/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__